import Component from "../abstracts/Component";

export default class ProductCardSwatchesComponent extends Component {

  get COMPONENTNAME() {
    return "ProductCardSwatchesComponent";
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.swatchesTrigger = this.$component.querySelector('[data-swatches-trigger]');
    this.swatches = this.$component.querySelectorAll('[data-js-swatch]');
  }

  handleShowSwatches() {
    this.swatchesTrigger.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.swatchesTrigger.classList.add("hidden");
      this.swatches.forEach(swatch => {
        swatch.classList.remove("hidden");
      });
    });
  }

  render() {
    super.render();
    if(this.swatchesTrigger) {
      this.handleShowSwatches();
    }
  }
}
